import React from 'react'
import cx from 'classnames'

import CloseButton from './CloseButton.jsx'
import './Modal.scss'

const getCloseButton = (callbackCloseModal, hasImage) => (
  <div className="site-close-modal-button">
    {hasImage}
    <CloseButton outlineOnly={!hasImage} onClickButton={callbackCloseModal} />
  </div>
)

const Modal = ({
  className,
  overlayColor,
  imageURL,
  callbackCloseModal,
  children,
  video,
  overlayStyles,
  hideCloseButton
}) => {
  const hasImage = Boolean(imageURL)

  return (
    <div className={cx('site-modal-container', className)}>
      <div
        className={cx(
          { 'site-modal-with-image': hasImage, 'site-simple-modal': !hasImage },
          video ? 'video' : '',
          overlayStyles ? overlayStyles : ''
        )}
      >
        <div className={cx('site-modal-content text-left', video ? 'video' : '')}>
          {children}
        </div>
        {hasImage && (
          <div
            className="site-modal-image"
            style={{ background: `url('${imageURL}') no-repeat center` }}
          />
        )}
        {!hideCloseButton && getCloseButton(callbackCloseModal, hasImage)}
      </div>

      <div
        className={cx('site-modal-overlay', video ? 'video' : '', overlayColor ? overlayColor : '')}
        onClick={callbackCloseModal}
      />
    </div>
  )
}

export default Modal



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/Modal.jsx